const STATUSES = {
    pendingBuyout: 'PENDING-BUYOUT',
    prepaid: 'PREPAID',
}

module.exports = STATUSES